<script>
	import { onMount } from "svelte";
	import Debug from "./components/Debug.svelte";
	import Lead from "./components/Lead.svelte";
	import Slide from "./components/Slide.svelte";
	import Fullscreen from "./components/Fullscreen.svelte";
	import content from "./content.yml";
	import { start, config } from "./mapscrolly";
	import featureDetect from "./feature-detect";
  //import InApp from 'detect-inapp';

	const scrollsections = content.filter((x) => x.type === "scroll");

	scrollsections.forEach((s) => {
		s.slides.forEach((sl) => {
			if (sl.positionLandscape === undefined) sl.positionLandscape = sl.position;
			if (sl.positionPortrait === undefined) sl.positionPortrait = sl.position;
		});
	});

	let mapContainer;
	let mapOverlay;
	let scrollyContainer;

  const debug = VERSION === "dev";

	let orientation = "landscape";
	let size;
  let scrn = config.screen;

  let inappios = false;

	function cbk(o, s, sc) {
		$: orientation = o;
		$: size = s;
		$: scrn = sc;
  }

	onMount(() => {
		start(mapContainer, mapOverlay, content, debug, cbk);
    featureDetect.start(scrollyContainer);
	});
</script>

{#if debug}
	<Debug />
{/if}

<div class="scrolly" bind:this={scrollyContainer} class:inapp={inappios}>
	<div class="map-container">
		<div class="map" bind:this={mapContainer} />
		<div class="map-overlay" bind:this={mapOverlay} />
	</div>

	<div class="content">
		{#each content as block}
			<!-- scroll sections -->
			{#if block.type == "scroll"}
				<div
					class="scrolly-block"
					bind:this={block.elem}
					style:height={(orientation === "landscape"
						? block.lengthLandscape
						: block.lengthPortrait) *
						scrn +
						"px"}
				>
					{#each block.slides as slide}
						<Slide
							heading={slide.heading}
							text={slide.text}
							image={slide.image}
							imageCaption={slide.imageCaption}
							imageCredit={slide.imageCredit}
							top={scrn *
								(orientation === "landscape" ? slide.positionLandscape : slide.positionPortrait)}
						/>
					{/each}
				</div>

				<!-- fullscreen sections -->
			{:else if block.type == "fullscreen"}
				<Fullscreen
					heading={block.heading}
					bind:elem={block.elem}
					text={block.text}
					textAfterImages={block.textAfterImages}
					image1={block.image1}
					image2={block.image2}
					image3={block.image3}
					subtitle1={block.subtitle1}
					subtitle2={block.subtitle2}
					content={block.content}
				/>

				<!-- lead section -->
			{:else if block.type == "lead"}
				<Lead kicker={block.kicker} heading={block.heading} teaser={block.teaser} paywall={false} />
			{/if}
		{/each}
	</div>
</div>

<style>
	.scrolly {
		font-family: "Abril Text", Helvetica, Arial, sans-serif;
		font-size: 20px;
		line-height: 32px;
		color: #000;
		position: relative;
	}

	/*
	.scrolly::after {
		content: " ";
		position: absolute;
		bottom: 0;
		left: 0;
		height: 100vh;
		width: 100%;
		background: linear-gradient(to bottom, rgba(21, 26, 39, 0) 0%, rgba(21, 26, 39, 1) 100%);
  }
  */

	:global(.tslr.tslr--dark .tslr-article-bottom) {
		background-color: #151a27;
		color: #fff;
	}
	:global(.tslr.tslr--dark) {
		background-color: #151a27;
	}

	@media (max-width: 480px) {
		.scrolly {
			font-size: 17px;
			line-height: 26px;
		}
	}

	@media (orientation: landscape) and (max-width: 1100px) {
		.scrolly {
			font-size: 18px;
			line-height: 27px;
		}
	}

	.map-container {
		position: sticky;
		top: 0;
		width: 100%;
		height: 100vh;
  }

  .inapp .map-container {
    height: calc(100vh + 138px);
  }

	.map,
	.map-overlay {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
	}

	.map-overlay {
		background-color: #151a27;
		opacity: 0;
		will-change: opacity;
    transform: translateZ(0);
    z-index: 2;
	}

	.map-overlay:global(.fullscreen) {
		opacity: 1 !important;
		transition: opacity 0.2s;
	}

	.content {
		position: relative;
		margin-top: -100vh;
	}

	/*
	:global(.mapboxgl-control-container) {
		display: none !important;
  }
  */

	:global(.mapboxgl-ctrl-bottom-left) {
		transform: scale(0.7);
		transform-origin: bottom left;
		opacity: 0.4;
		pointer-events: all;
	}

	:global(.mapboxgl-ctrl-bottom-right) {
		transform: scale(0.7);
		transform-origin: bottom right;
		opacity: 0.4;
		pointer-events: all;
		bottom: 4px;
	}

	.scrolly-block {
		position: relative;
	}

	.scrolly .content :global(p),
	.scrolly .content :global(h1),
	.scrolly .content :global(h2),
	.scrolly .content :global(h3) {
		width: 620px;
		max-width: 100%;
	}

	:global(.tslr.tslr--dark a:hover) {
		color: #cd0100;
		text-decoration-color: #cd0100;
	}

	:global(.tslr.tslr--dark .tslr-infobox-container .tslr-infobox-kicker) {
		color: #cd0100;
	}

	:global(.tslr.tslr--dark .tslr-author__social a:hover span) {
		color: #cd0100;
	}

	:global(.mapboxgl-ctrl-attrib-inner) {
		color: #fff !important;
	}

	:global(.mapboxgl-ctrl-attrib a) {
		color: #fff !important;
	}

	:global(.mapboxgl-ctrl.mapboxgl-ctrl-attrib) {
		background-color: transparent !important;
  }

    .scrolly :global(a.mapboxgl-ctrl-logo) {
      width: 88px;
      height: 23px;
      margin: 0 0 -4px -4px;
      display: block;
      background-repeat: no-repeat;
      cursor: pointer;
      overflow: hidden;
      background-position: center center;
      background-size: contain;
      background-image: url(data:image/svg+xml;charset=utf-8;base64,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);
    }
</style>
